<template>
    <div v-if="isSupplier" class="upload-media">
        <div class="upload-media__form" @click="ShowUploadMediaPopup = true">
            <template v-if="!previewImg">
                <div class="upload-media__form-icon"></div>
                <div class="upload-media__form-text">Загрузить файлы</div>
            </template>
            <template v-else>
                <div class="upload-media__form-bg" :style="`background-image: url(${previewImg})`"></div>
                <div class="upload-media__form-txt">
                    <span>{{ previewCount }}</span>
                    Изменить
                </div>
            </template>
        </div>
    </div>
    <div class="u-link"  v-else @click="ShowUploadMediaPopup = true">
        {{ files.length }} {{ getFileName }}
    </div>
    <teleport to='body'>
        <transition name="modal">
            <UploadMediaPopup v-if="ShowUploadMediaPopup" @close="ShowUploadMediaPopup = false" @addFiles="saveFiles($event)" :files="files" :is-supplier="isSupplier"/>
        </transition>
    </teleport>
</template>

<script>
import UploadMediaPopup from "@/components/sections/Tenders/TenderInner/UploadMediaPopup.vue";
import objectToFormData from "@/utils/ObjectToFormData";
import Fetch from "@/utils/Fetch";
import { useToast } from "vue-toastification";
import {getNoun} from "@/utils/helpers";

export default {
    name: 'UploadMedia',
    emits: ['updateTender'],
    components: {
        UploadMediaPopup
    },
	props: {
		positionId: {
			type: Number,
			required: true
		},
        files: {
            type: Array,
            default: () => []
        },
        isSupplier: {
            type: Boolean,
            default: true
        },
        offerCOId: {
            type: Number
        }
    },
    data() {
        return {
            toast: useToast(),
            ShowUploadMediaPopup: false,
            previewImg: null,
            previewCount: 0,
            storageFiles: []
        }
    },
    created() {
        if(this.files.length) {
            this.previewImg = this.files[0].file
            this.previewCount = this.files.length 
        }
    },
    computed: {
        getFileName() {
           return getNoun(this.files.length, 'файл', 'файла', 'файлов')
        }   
    },
    methods: {
        saveFiles(files) {
            this.storageFiles = files
            this.previewImg = URL.createObjectURL(files[0])
            this.previewCount = files.length 
        },
		async sendForm() {
            if(!this.storageFiles.length) {
                return
            }
			const body = objectToFormData({
				files: this.storageFiles,
				position: this.positionId,
                offer: this.offerCOId
			})

			let response = await Fetch('tenders/positions/set-files/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.storageFiles = []
                this.previewImg = null
                this.previewCount = 0

			} else {
				this.toast.error(response.message);
			}
		}
    }
}
</script>
